<section *ngIf="data && data.length" class="mt-3 d-none d-sm-block" [ngClass]="{'d-none': !show}">
  <div matBadge="{{getMessageCount()}}" matBadgeOverlap="false" matBadgeColor="warn" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6 mt-2" i18n>Notifikácie</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>

    <app-sub-messages
            *ngFor="let m of data" [data]="m"
            (onGroupDeleted)="removeGroup($event)">
    </app-sub-messages>

    <hr/>
    <div class="d-flex flex-row align-items-center">
      <b><a class="text-decoration-none" [matMenuTriggerFor]="menu" i18n>Údržba notifikácii</a></b>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="deleteOneMonthOldMessages()">
          <mat-icon style="overflow: visible;">fiber_manual_record</mat-icon> <span i18n>Zmazať notifikácie staršie ako 1 mesiac</span>
        </button>
        <button mat-menu-item (click)="deleteAllMessages()">
          <mat-icon>fiber_manual_record</mat-icon> <span i18n>Zmazať všetky notifikácie</span>
        </button>
      </mat-menu>
    </div>
  </mat-expansion-panel>
</section>
